import { c as _c } from "react/compiler-runtime";
import { usePaymentMethodsWithIssues } from '@sola/supporter-sdk/hooks/payment-methods.ts';
import { PaymentMethodAlert, PaymentMethodAlertProps, shouldRenderPaymentMethodAlert } from '../../molecules/payment-method-alert/payment-method-alert.tsx';
import { MakeAPaymentNotice, MakeAPaymentNoticeProps } from '../make-a-payment/make-a-payment-notice.tsx';
export const PaymentIssueAlert: React.FC<PaymentMethodAlertProps & MakeAPaymentNoticeProps> = alertProps => {
  const $ = _c(4);
  const {
    paymentMethodsWithIssues,
    associatedCommitments
  } = usePaymentMethodsWithIssues();
  const {
    isSimple,
    onlyShowMissingPayment
  } = alertProps;
  if (shouldRenderPaymentMethodAlert({
    paymentMethodsWithIssues,
    associatedCommitments,
    isSimple
  })) {
    let t0;
    if ($[0] !== isSimple) {
      t0 = <PaymentMethodAlert isSimple={isSimple} />;
      $[0] = isSimple;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  let t0;
  if ($[2] !== onlyShowMissingPayment) {
    t0 = <MakeAPaymentNotice onlyShowMissingPayment={onlyShowMissingPayment} />;
    $[2] = onlyShowMissingPayment;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
};